import styled from "styled-components";

// styles
import colors from "core/colors";
import breakpoints from "core/breakpoints";
import Link from "core/Link";
import { regular as regularFontWeight } from "core/fontStyles";
import { convertPxToRem } from "frontend/components/helpers";
import { CustomFocusStyle } from "core/Typography";

// styled-components
export const AttributionDisplayTextStyled = styled.div`
    width: 100%;
    padding: 0;
    font-family: inherit;
    color: ${({ darkMode }) =>
        darkMode ? colors.primary.snow : colors.secondary.oolong};
    font-size: ${convertPxToRem({ px: 13 })};
    line-height: ${convertPxToRem({ px: 16 })};
    resize: none;
    user-select: all;
    border: none;
    margin-right: ${convertPxToRem({ px: 16 })};
    ${CustomFocusStyle}
`;

export const TnpLinkStyled = styled(Link)`
    color: ${colors.secondary.oolong};
    > span {
        border-bottom-color: ${colors.secondary.oolong};
    }
    ${regularFontWeight}

    &:visited,
    &:hover,
    &:visited:hover {
        color: ${colors.secondary.oolong};
        > span {
            border-bottom-color: ${colors.secondary.oolong};
        }
    }

    @media (min-width: ${breakpoints.tablet.rem}) {
        color: ${colors.primary.snow};
        > span {
            border-bottom-color: ${colors.primary.snow};
        }

        &:visited,
        &:hover,
        &:visited:hover {
            color: ${colors.primary.snow};
            > span {
                border-bottom-color: ${colors.primary.snow};
            }
        }
    }
`;
